import React from "react";

interface InputRadioProps {
  options: any;
  value: string;
  onChange: (e: any) => void;
  className?: string;
  name?: string;
  "data-testid"?: string;
  "aria-label"?: string;
}

const InputRadio = (props: InputRadioProps) => {
  const {
    options,
    value,
    onChange,
    className = "",
    name = "radio-group",
    ...radioProps
  } = props;

  return (
    <div
      role="radiogroup"
      aria-label={radioProps["aria-label"]}
      data-testid={radioProps["data-testid"]}
    >
      <div className="flex items-center gap-[50px]">
        {options?.map((x: any) => {
          const optionTestId = radioProps["data-testid"]
            ? `${radioProps["data-testid"]}-option-${String(x.value)
                .trim()
                .replace(/[^a-zA-Z0-9]+/g, "-")
                .replace(/^-+|-+$/g, "")
                .toLowerCase()}`
            : undefined;
          return (
            <label
              key={x.value}
              htmlFor={`${name}-${x.value}`}
              className="flex items-center w-max cursor-pointer gap-2 py-3 -my-3"
              onClick={() => {
                onChange({ target: { value: x.value } });
              }}
            >
              <div className="inline-flex items-center">
                <label
                  className="relative flex items-center p-0 rounded-full cursor-pointer"
                  htmlFor={`${name}-${x.value}`}
                >
                  <input
                    name={name}
                    id={`${name}-${x.value}`}
                    type="radio"
                    value={x.value}
                    checked={x.value === value}
                    onChange={onChange}
                    data-testid={optionTestId}
                    aria-label={x.name}
                    className="before:content[''] peer relative h-[18px] w-[18px] cursor-pointer appearance-none rounded-full border border-strokePrimary transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-[18px] before:w-[18px] before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue before:opacity-0 before:transition-opacity checked:border-strokeActive checked:before:bg-blue hover:before:opacity-0"
                  />
                  {x.value === value ? (
                    <span className="absolute transition-opacity pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4">
                      <svg
                        className="h-3 w-3"
                        viewBox="0 0 16 16"
                        fill="var(--color-blue)"
                      >
                        <circle
                          data-name="ellipse"
                          cx="8"
                          cy="8"
                          r="8"
                        ></circle>
                      </svg>
                    </span>
                  ) : null}
                </label>
              </div>
              <p
                className={`text-sm text-txtSecondary font-bold leading-normal ${className}`}
              >
                {x?.name}
              </p>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default InputRadio;
